module.exports = __webpack_public_path__ + "img/Services_connecting_mobile.9603e142.png";